import Vue from 'vue'
import Router from 'vue-router'

import login from '@/module/index/index.vue'
import center from '@/module/center/center.vue'
import course from '@/module/course/course.vue'
import detail from '@/module/detail/detail.vue'
import exam from '@/module/exam/exam.vue'
import pxzm from '@/module/pxzm/pxzm.vue'
import report from '@/module/report/report.vue'

import qyrz from '@/components/index/index_new.vue'
import ddsh from '@/components/index/index_ddsh.vue'
import dzf from '@/components/index/index_dzf.vue'
import yzf from '@/components/index/index_yzf.vue'
import cfzl from '@/components/index/index_cfzl.vue'
import index from '@/components/index/index_index.vue'
import xy from '@/components/index/xy.vue'
import search from '@/components/index/index_search.vue'


import index_pxkc from '@/components/index/index_pxkc.vue'

import authorize from '@/components/index/authorize.vue'
import videoDetail from '@/components/index/wechat_video_detail.vue'

// menu
import indexContent from '@/components/index/indexContent.vue' //首页
import courseIndex from '@/components/index/courseIndex.vue' // 课程分类
import courseDetail from '@/components/index/courseDetail.vue' // 课程详情
// import creditCourses from '@/components/index/creditCourses.vue' // 信用课程
import announcement from '@/components/index/announcement.vue' // 公示公告
import services from '@/components/index/services.vue' // 服务支持

import schedule from '@/components/index/schedule.vue' // 课程进度

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      component: index,
      meta: {
        title: '汇信网—信用培训'
      },
      children: [{
          path: '/',
          name: 'indexContent',
          component: indexContent
        },{
          path: 'courseIndex',
          name: 'courseIndex',
          component: courseIndex
        },{
          path:'courseDetail',
          name:'courseDetail',
          component:courseDetail
        },
        {
          path:'announcement',
          name:'announcement',
          component:announcement
        },
        {
          path:'services',
          name:'services',
          component:services
        },{
          path:'schedule',
          name:'schedule',
          component:schedule
        }
      ]
    },
    {
      path: '/index',
      component: index,
      meta: {
        title: '汇信网—信用培训'
      }
    },
    {
      path: '/index_pxkc',
      component: index_pxkc,
      meta: {
        title: '汇信网—信用培训'
      }
    }, {
      path: '/xy',
      component: xy,
      meta: {
        title: '汇信网—信用培训'
      }
    }, {
      path: '/center',
      component: center,
      meta: {
        title: '汇信网—学习中心'
      }
    }, {
      path: '/course',
      component: course,
      meta: {
        title: '汇信网—专题培训'
      }
    }, {
      path: '/detail',
      component: detail,
      meta: {
        title: '汇信网—专题培训'
      }
    }, {
      path: '/exam',
      component: exam,
      meta: {
        title: '汇信网—考试考核'
      }
    }, {
      path: '/pxzm',
      component: pxzm,
      meta: {
        title: '汇信网—培训证明'
      }
    }, {
      path: '/report',
      component: report,
      meta: {
        title: '汇信网—信用报告'
      }
    }, {
      path: '/qyrz',
      component: qyrz,
      meta: {
        title: '汇信网—信用培训'
      }
    }, {
      path: '/ddsh',
      component: ddsh,
      meta: {
        title: '汇信网—信用培训'
      }
    }, {
      path: '/dzf',
      component: dzf,
      meta: {
        title: '汇信网—信用培训'
      }
    }, {
      path: '/yzf',
      component: yzf,
      meta: {
        title: '汇信网—信用培训'
      }
    }, {
      path: '/cfzl',
      component: cfzl,
      meta: {
        title: '汇信网—信用培训'
      }
    }, {
      path: '/login',
      component: login,
      meta: {
        title: '汇信网—登录'
      }
    }, {
      path: '/search',
      component: search,
      meta: {
        title: '汇信网-培训企业名录'
      }
    }, {
      path: '/authorize',
      component: authorize,
      meta: {
        title: '汇信网-授权'
      }
    }, {
      path: '/videodetail',
      component: videoDetail,
      meta: {
        title: '培训课程'
      }
    },

    {
      path: '*',
      redirect: "/"
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js